import React, { useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@emotion/react';
import theme from './theme';
import './App.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './fonts/PPPangramSans-Light.otf';
import { AppRoutes } from './routes';
import { worker } from './mocks/browser';

const App: React.FC = () => {
  const [workerStarted, setWorkerStarted] = useState(false);
  worker.start().then(() => setWorkerStarted(true));
  if (!workerStarted) return null;
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppRoutes />
    </ThemeProvider>
  );
};

export default App;
